export const APPLICATION_TYPE_OPTIONS = [
  { label: 'Counter', value: 'COUNTER' },
  { label: 'Kiosk', value: 'KIOSK' },
];

export const SESSION_STATUS = {
  active: 'ACTIVE',
  history: 'HISTORY',
};

export const NO_ACTIVITY_DAYS = 20;
